import { RootStateOrAny } from 'react-redux'

export const getMenuIsLoaded = (state: RootStateOrAny): boolean => state.menuMetadata.isLoaded
